<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/courses']" [queryParams]="{tab:tab}"><img
            src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="imgUploadWrap">
                        <span class="userCouresImage" style="background: url(assets/images/demo.png);"></span>
                        <!-- <div class="imgUpload">
                            <input type="file" />
                            <span>CHANGE PICTURE</span>
                        </div> -->
                    </div>
                    <div class="userCouresContent">
                        <h3>{{courseData.course_name}}</h3>
                        <p>
                            <span *ngIf="courseData.module_count <= 1">{{courseData.module_count}} Module</span>
                            <span *ngIf="courseData.module_count > 1">{{courseData.module_count}} Modules</span>
                            <span *ngIf="courseData.submodule_count <= 1">{{courseData.submodule_count}} Sub Module</span>
                            <span *ngIf="courseData.submodule_count > 1">{{courseData.submodule_count}} Sub Modules</span>
                            <span *ngIf="courseData.assessment_count <= 1">{{courseData.assessment_count}} Assessment</span>
                            <span *ngIf="courseData.assessment_count > 1">{{courseData.assessment_count}} Assessments</span>
                        </p>
                        <p>
                            <span>Created by: {{courseData.created_by}} on {{courseData.created_dttm}}</span>
                        </p>
                        <p>
                            <span>End Date: {{courseData.end_date}}</span>
                            <!-- <a href="javascript:void(0);" class="btn-link" >EXTEND</a> -->
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs">
                    <p>{{courseData.course_desc}}</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_courses']"
                                [queryParams]="{courseId:courseId,tab:tab}" class="active">VIEW COURSES</a> </li>
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']"
                            [queryParams]="{courseId:courseId,tab:tab}">VIEW USERS</a> </li>
                        <li *ngIf="courseData.is_active==1"><a href="javascript:void(0);" [routerLink]="['/courses_assign_users']"
                            [queryParams]="{courseId:courseId,tab:tab}">ASSIGN USERS</a> </li>
                        <li ><a href="javascript:void(0);"(click)="open(duplicate)" >DUPLICATE</a> </li>
                        <li class="deactiveTab" *ngIf="courseData.is_active==1"><a href="javascript:void(0);"
                            (click)="open(deactivate)">DEACTIVATE</a> </li>
                        <li class="deactiveTab" *ngIf="courseData.is_active==0"><a href="javascript:void(0);"
                                (click)="open(activate)">ACTIVATE</a> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="tabsWrap courseViewCourse">
    <div class="clearfix">
        <mat-tab-group animationDuration="0ms" [selectedIndex]="activeTab" >
            <mat-tab *ngFor="let values of courseData.courseModules; let i = index">
                <ng-template mat-tab-label>
                    <b>Module {{i+1}}:</b>{{values.module_name}}
                </ng-template>
                <div class="contentBody">
                    <div class="pl-4 mt-4 pr-4">
                        <div class="moduleHead">
                            <div class="mudleSubHead">
                                <h3><b>Module {{i+1}}:</b>{{values.module_name}}</h3>
                                <!-- <ul class="modifyIcons">
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img
                                                src="assets/images/icons/insert-picture.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img
                                                src="assets/images/icons/video-camera.svg" /></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                        <p>{{values.module_desc}}</p>
                        <a href="javascript:void(0);"
                        *ngIf="values.assessment_id !=''"
                        class="btn btn-primary btn-sm ml-1 mr-1"
                        [routerLink]="['/course_assessment_view']"
                        [queryParams]="{id:values.assessment_id,course_id:values.course_id}"><span>View
                            assessment</span></a>
                    </div>
                    <hr />
                    <div class="submudleWrap mh-100">
                        <mat-accordion>
                            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                                *ngFor="let subValues of values.subModules; let j = index">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="moduleHead">
                                            <div class="submudleHead">
                                                <h3> <b>SUB MODULE {{j+1}}:</b>{{subValues.submodule_name}}</h3>
                                                <div class="viewpass">
                                                    <a href="javascript:void(0);"
                                                    *ngIf="subValues.assessment_id !='' && subValues.assessment_id != null"
                                                    class="btn btn-primary btn-sm ml-1 mr-1"
                                                    [routerLink]="['/course_assessment_view']"
                                                    [queryParams]="{id:subValues.assessment_id,course_id:subValues.course_id}"><span>View
                                                        assessment</span></a>
                                                </div>
                                                <ul class="modifyIcons">
                                                    <li *ngIf="subValues.assessment_id"><a href="javascript:void(0);"><img
                                                                src="assets/images/icons/frame.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[1]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[2]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>

                                                </ul>
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>{{subValues.submodule_desc}}</p>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div> 
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate course</h6>
                <p class="size18">Are you sure you want to duplicate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCourse(courseId)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div *ngIf="activeCourse">
                <h6>Extend </h6>
                <p class="size18">Select a date to extend the end date of the course.</p>
                <div class="commanInput commanDate">
                    <mat-form-field class="example-full-width">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [matDatepicker]="picker" placeholder="Select Date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="successClick()" class="btn btn-primary btn-sm">Extend Course</a>
            </div>
            <div *ngIf="succesCourse">
                <figure><img src="assets/images/admin/circle_check.png" /></figure>
                <p class="size18">You have successfully activated the course.<br />
                    You can now assign users!</p>
                <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                    (click)="modal.dismiss('Cross click')">Close</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="modal.dismiss('Cross click')">Assign Users now</a>
            </div>
        </div>
    </div>
</ng-template>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate course</h6>
                <p class="size18">Are you sure you want to activate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(1)"
                    >Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(0)"
                    >Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>